'use client';

import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren, useEffect, useState } from 'react';
import { useSignal, viewport } from '@tma.js/sdk-react';
import Image from 'next/image';
interface Props {
  isBrowser: boolean;
}
export default function SplashScreen(t0) {
  const $ = _c(10);
  const {
    isBrowser,
    children
  } = t0;
  const width = useSignal(viewport.width);
  const stableHeight = useSignal(viewport.stableHeight);
  const [isPortrait, setIsPortrait] = useState(true);
  let t1;
  let t2;
  if ($[0] !== isBrowser) {
    t1 = () => {
      if (!isBrowser) {
        return;
      }
      const updateOrientation = () => setIsPortrait(window.innerHeight >= window.innerWidth);
      updateOrientation();
      window.addEventListener("resize", updateOrientation);
      window.addEventListener("orientationchange", updateOrientation);
      return () => {
        window.removeEventListener("resize", updateOrientation);
        window.removeEventListener("orientationchange", updateOrientation);
      };
    };
    t2 = [isBrowser];
    $[0] = isBrowser;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const backgroundSrc = (isBrowser ? isPortrait : stableHeight >= width) ? "/splash-portrait.webp" : "/splash-landscape.webp";
  let t3;
  if ($[3] !== backgroundSrc) {
    t3 = <Image src={backgroundSrc} alt="Splash Screen" priority={true} fill={true} />;
    $[3] = backgroundSrc;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children) {
    t4 = children && <div className="flex items-center justify-center-safe"><div className="min-h-screen backdrop-blur-lg backdrop-brightness-75 flex flex-col gap-4 items-center justify-center-safe p-4">{children}</div></div>;
    $[5] = children;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="relative w-dvw min-h-screen">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}